module.exports = __webpack_public_path__ + "static/media/square_logo_transparent.dd701414.png";